/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule relayUnstableBatchedUpdates
 * 
 */

'use strict';

module.exports = require('react-dom').unstable_batchedUpdates;


//////////////////
// WEBPACK FOOTER
// ./~/react-relay/lib/relayUnstableBatchedUpdates.js
// module id = 743
// module chunks = 0